export enum TagHighlightType {
  Hot = 'hot',
  Protection = 'protection',
  Opinion = 'opinion',
}
